import React, { useCallback } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import Global from '../../store/global-selectors';
import { emptyArray } from 'ui-components/default-props/empty';
import { useModal } from '../../hooks/use-modal';
import { BulkReshipModal } from './bulk-reship-modal';
import { bulkReshipStart } from '../../store/bulk/reship/bulk.reship.actions';

import { RESHIP_SHIPMENT_ACTIONS, useTrackBulkReshipShipmentAction } from './use-track-reship-action';

import { messages } from './messages';
import style from '../../components/grid-header/shared-classes.module.less';

export const BulkReshipButton = () => {
  const selectedFulfillmentPlanIds = useSelector((state) => Global.selectSelectedOrdersIds(state)) || emptyArray;
  const dispatch = useDispatch();

  const trackReshipShipmentOpen = useTrackBulkReshipShipmentAction(RESHIP_SHIPMENT_ACTIONS.START, selectedFulfillmentPlanIds);
  const trackReshipShipmentClose = useTrackBulkReshipShipmentAction(RESHIP_SHIPMENT_ACTIONS.CLOSE, selectedFulfillmentPlanIds);

  const trackReshipShipmentSuccess = useTrackBulkReshipShipmentAction(RESHIP_SHIPMENT_ACTIONS.SUCCESS, selectedFulfillmentPlanIds);
  const trackReshipShipmentError = useTrackBulkReshipShipmentAction(RESHIP_SHIPMENT_ACTIONS.ERROR, selectedFulfillmentPlanIds);

  const { isOpen, open, close } = useModal();

  const onBulkReshipClick = useCallback(() => {
    open();
    trackReshipShipmentOpen();
  }, [open, trackReshipShipmentOpen]);

  const onBulkReshipClose = useCallback(() => {
    close();
    trackReshipShipmentClose();
  }, [close, trackReshipShipmentClose]);

  const onBulkReship = useCallback(() => {
    dispatch(
      bulkReshipStart({
        fulfillmentPlanIds: selectedFulfillmentPlanIds,
        trackReshipShipmentSuccess,
        trackReshipShipmentError,
      }),
    );
    onBulkReshipClose();
  }, [dispatch, selectedFulfillmentPlanIds, trackReshipShipmentSuccess, trackReshipShipmentError, onBulkReshipClose]);

  return (
    <>
      <Button
        className={style['action-button']}
        disabled={selectedFulfillmentPlanIds.length === 0}
        onClick={onBulkReshipClick}
        theme='primary'
      >
        <FormattedMessage {...messages.reshipButton} />
      </Button>
      <BulkReshipModal fulfillmentPlanIds={selectedFulfillmentPlanIds} onAction={onBulkReship} onClose={onBulkReshipClose} show={isOpen} />
    </>
  );
};
